export const PROJECTS_QUERY_KEY = 'projects';
export const GITLAB_GROUPS_KEY = 'gitlab-groups';
export const GITLAB_SUBGROUPS_KEY = 'gitlab-subgroups';
export const CLI_QUERY_KEY = 'cli-data';
export const IAS_PROJECTS_QUERY_KEY = 'ias-projects';
export const IAS_PROJECT_CONFIG_QUERY_KEY = 'ias-project-config';
export const IAS_PROJECT_TEMPLATE_README_QUERY_KEY =
  'ias-project-template-readme';
export const IAS_PROJECT_USED_UNIQUE_VALUES_QUERY_KEY =
  'ias-project-used-unique-values';
export const IAS_PROJECT_INSTANCE_STATE_QUERY_KEY =
  'ias-project-instance-state';
export const DEFAULT_PARAM_GROUP = 'default-param-group';
export const DEFAULT_FEATURE_GROUP = 'default-feature-group';
export const RECOMMENDED_FEATURE_GROUP = 'recommended-feature-group';
export const USERS_KEY = 'users';
export const GITLAB_ME_KEY = 'gitlab-me';
export const SONAR_PERMISSION_GROUPS = 'sonar-permission-groups';
export const PROJECT_PRESETS_QUERY_KEY = 'project-presets-query-key';
export const ITEMS_PER_PAGE = 20;
export const ATLASSIAN_ME_KEY = 'atlassian-me';
export const ATLASSIAN_JIRA_PROJECT_KEY = 'atlassian-jira-project';
export const ATLASSIAN_CONFLUENCE_SPACE_ID = 'atlassian-confluence-space-id';
export const ATLASSIAN_CONFLUENCE_SPACES = 'atlassian-confluence-spaces';
export const ATLASSIAN_CONFLUENCE_PAGE_CHILDREN =
  'atlassian-confluence-page-children';
export const GIT_REMOTE_REF_KEY = 'git-remote-ref';
export const SPDX_LICENSES_KEY = 'spdx-licenses';
export const GITLAB_OSEP_PIPELINE_VARIABLE_QUERY_KEY =
  'osep-gitlab-pipeline-variable';
